import 'jquery';
import '../utils/slick.js';

$(function () {
  const list_1_logos = $('.list-1-logos');
  list_1_logos.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    dots: false,
    infinite: true,
    slidesToShow: 3,
    speed: 6000,
    swipe: false,
    centerMode: true,
    centerPadding: '20px',

    init: function (event, slick) {
      list_1_logos.find('.slick-slide').css('opacity', 0);
      list_1_logos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });

  const list_2_logos = $('.list-2-logos');
  list_2_logos.slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    arrows: false,
    swipe: false,
    slidesToShow: 3,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    rtl: true,
    centerMode: true,
    centerPadding: '20px',

    init: function (event, slick) {
      list_2_logos.find('.slick-slide').css('opacity', 0);
      list_2_logos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });

  const list_3_logos = $('.list-3-logos');
  list_3_logos.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    dots: false,
    infinite: true,
    slidesToShow: 3,
    speed: 6000,
    swipe: false,
    centerMode: true,
    centerPadding: '20px',

    init: function (event, slick) {
      list_3_logos.find('.slick-slide').css('opacity', 0);
      list_3_logos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });

  const list_4_logos = $('.list-4-logos');
  list_4_logos.slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    arrows: false,
    swipe: false,
    slidesToShow: 2,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    rtl: true,
    centerMode: true,
    centerPadding: '20px',

    init: function (event, slick) {
      list_4_logos.find('.slick-slide').css('opacity', 0);
      list_4_logos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });
});
